var components
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  var l0 = _vm.loading
    ? _vm.__map(_vm.RectNodes, function (item, index) {
        var $orig = _vm.__get_orig(item)
        var g0 = _vm.$u.guid()
        return {
          $orig: $orig,
          g0: g0,
        }
      })
    : null
  var l1 = _vm.loading
    ? _vm.__map(_vm.circleNodes, function (item, index) {
        var $orig = _vm.__get_orig(item)
        var g1 = _vm.$u.guid()
        return {
          $orig: $orig,
          g1: g1,
        }
      })
    : null
  var l2 = _vm.loading
    ? _vm.__map(_vm.filletNodes, function (item, index) {
        var $orig = _vm.__get_orig(item)
        var g2 = _vm.$u.guid()
        return {
          $orig: $orig,
          g2: g2,
        }
      })
    : null
  _vm.$mp.data = Object.assign(
    {},
    {
      $root: {
        l0: l0,
        l1: l1,
        l2: l2,
      },
    }
  )
}
var recyclableRender = false
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns, recyclableRender, components }